import { StepperParamsTypes } from 'components'
import { useContext, createContext } from 'react'
import { StepContextProps } from './Stepper.context.types'

export const StepperContext = createContext({})

export function useStepper<T = StepperParamsTypes>() {
  return useContext(StepperContext) as StepContextProps<T>
}
